<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('nomor')">Nomor <i
                :class="currentSort === 'nomor' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('deskripsi')">Deskripsi <i
                :class="currentSort === 'deskripsi' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('aliasing')">Alias pada Profil <i
                :class="currentSort === 'aliasing' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('aliasing')">Alias pada SAP <i
                :class="currentSort === 'aliasing' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('last_modified_date')">Last Modified Date <i
                :class="currentSort === 'last_modified_date' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('last_modified_by')">Last Modified By <i
                :class="currentSort === 'last_modified_by' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('status')">Status <i
                :class="currentSort === 'status' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('catatan')">Catatan <i
                :class="currentSort === 'catatan' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="badanUsaha.length === 0">
            <td colspan="8" class="text-center">Data saat ini kosong, silahkan ditambahkan.</td>
          </tr>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)"><span class="fa fa-edit pointer ml20"></span></td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ list.alias_profile }}</td>
            <td>{{ list.alias_sap }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ list.update_by ? list.update_by : 'System' }}</td>
            <td :style="{ color: list.is_active === 'Active' ? 'green' : 'red' }">{{ list.is_active ? 'Aktif' : 'Tidak'
            }}
            </td>
            <td>{{ list.catatan }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <EditInternasional v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
  </div>
</template>
    
<script>
export default {
  components: {
    EditInternasional: () => import('@/components/masterdata/matrix/perorangan/edit/internasional.vue')
  },

  props: {
    'isEdit': Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      isDataEmpty: true,
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        desc: data.desc,
        alias_profile: data.alias_profile,
        alias_sap: data.alias_sap,
        updatedAt: data.updatedAt,
        is_active: data.is_active,
        note: data.note,
      }
      this.showModalEdit = true;
    },
    closeModal() {
      this.showModalEdit = false;
    },
  },

  computed: {
    badanUsaha() {
      const badan = this.$store.state.mdMatrixLegalStore.badan_usaha
      let filterBadan = badan.filter((b) => b.type_pendaftaran_id === 2 && b.bidang_usaha_id === 2)
      return filterBadan
    },
    sortedData() {
      return this.badanUsaha.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    }
  },

}
</script>